<div class="sg-app-banner position-relative sg-py-4 lazyload" [attr.data-bgset]="backgroundImage">
    <div class="sg-app-banner-container">
        <div class="container">
            <div class="row">
                <div class="col-12 col-md-6 sg-color__white sg-pt-2">
                    <div class="sg-heading__h2 text-uppercase text-center text-md-left">{{appBanner.heading}}</div>
                    <div class="sg-heading__h1 text-uppercase text-center text-md-left sg-mb-1">{{appBanner.subheading}}</div>

                    <div [class.mb-2]="!last" *ngFor="let item of appBanner.list; let last = last;">
                        <mlp-ng-icon name="check-1" class="sg-color -secondary"></mlp-ng-icon>
                        {{item}}
                    </div>

                    <div class="sg-mb-1 sg-mb-lg-2"></div>

                    <div class="d-flex flex-column flex-lg-row align-items-xs-center">
                        <a target="_blank" [href]="downloadIOS">
                            <img class="mb-2 mr-md-2 lazyload" height="48" [alt]="downloadIOSImgAlt" [attr.data-src]="downloadIOSImg">
                        </a>

                        <a target="_blank" [href]="downloadAndroid">
                            <img class="mb-2 lazyload" height="48" [alt]="downloadAndroidImgAlt" [attr.data-src]="downloadAndroidImg">
                        </a>
                    </div>
                </div>
                <div class="col-12 col-md-6 triangle sg-pt-1 sg-pt-md-2 pr-lg-0 sg-pb-2 pb-md-0">
                    <div class="d-flex justify-content-center justify-content-md--end">
                        <img [alt]="appPreviewImageAlt" class="app-placeholder lazyload" [attr.data-src]="appPreviewImage" imgService="w=250" />
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
